var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"homeContainer"}},[_vm._m(0),_c('english-badge')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meatPotatoes"},[_c('h2',{attrs:{"id":"title"}},[_vm._v("Programación Web y Software")]),_c('img',{staticClass:"logo",attrs:{"alt":"Campos logo","src":require("../../assets/Annie_Home_Page_Image.jpg")}})])
}]

export { render, staticRenderFns }